import React from 'react';
import { Search, X } from 'lucide-react';
import clsx from 'clsx';
import styles from './SearchInput.module.css';

interface SearchInputProps {
  value: string;
  onChange: (value: string) => void;
  placeholder?: string;
  className?: string;
  disabled?: boolean;
  autoFocus?: boolean;
  autoComplete?: string;
  dataTestId?: string;
  id?: string;
}

const SearchInput: React.FC<SearchInputProps> = ({
  value,
  onChange,
  placeholder = 'Search...',
  className = '',
  disabled = false,
  autoFocus = false,
  autoComplete = 'off',
  dataTestId,
  id
}) => {
  return (
    <div className={clsx(styles.searchBox, className)}>
      <Search size={16} className={styles.searchIcon} />
      <input
        id={id}
        type="text"
        placeholder={placeholder}
        value={value}
        onChange={(e) => onChange(e.target.value)}
        className={styles.searchInput}
        disabled={disabled}
        autoFocus={autoFocus}
        autoComplete={autoComplete}
        data-test-id={dataTestId}
      />
      {value && (
        <button
          className={styles.clearButton}
          onClick={() => onChange('')}
          title="Clear search"
          type="button"
          disabled={disabled}
        >
          <X size={16} />
        </button>
      )}
    </div>
  );
};

export default SearchInput;
